import { render } from "./App.vue?vue&type=template&id=277aa9c1"
const script = {}
script.render = render

export default script